@if (contacts().length === 0) {
  <rs-web-side-sheet-form
    #sideSheetFormComponent="rsWebSideSheetForm"
    [formGroup]="form"
    [showBackButton]="!showSuccessStep()"
    [showNav]="!isXsBreakpoint() && !showSuccessStep()"
    [loading]="saveTicketActionState()?.pending || detailQuestionsActionState()?.pending"
    [doneButtonText]="'ticket_creation.create_ticket_a'"
    (dismiss)="onDismiss($event)"
  >
    <span sidesheet-title class="primary-text">
      {{
        (type === TicketIssueType.PROPERTY_DAMAGE
          ? 'ticket_damage.create_new_l'
          : 'ticket_request.create_new_l'
        ) | translate
      }}</span
    >

    @if ((contracts$ | async)?.length > 1) {
      <ng-template
        rsWebSideSheetContent
        [label]="'main_navigation.contracts_l'"
        [currentStepValid]="(form.controls.contract.statusChanges | async) === 'VALID'"
        (next)="sideSheetFormComponent.nextTab()"
      >
        <div class="d-flex gap-2 mb-3 font-bold">
          <span class="primary-text">{{ 'consumption.select_contract_l' | translate }}</span>
        </div>
        <rs-web-select-contract
          class="primary-text"
          (contractChange)="onContractChange()"
        ></rs-web-select-contract>
      </ng-template>
    }

    <ng-template
      rsWebSideSheetContent
      [label]="'ticket_creation.categories_tab_l'"
      [currentStepValid]="(form.controls.categories.statusChanges | async) === 'VALID'"
      [customDoneButtonText]="'next'"
      (done)="onCategoriesStepDone(sideSheetFormComponent)"
      (next)="onCategoriesStepDone(sideSheetFormComponent)"
    >
      <rs-web-ticket-categories
        class="primary-text"
        (categoryQuestionChange)="onCategoryQuestionChange()"
      ></rs-web-ticket-categories>
    </ng-template>

    @if (showDetailStep()) {
      <ng-template
        rsWebSideSheetContent
        [label]="'ticket_creation.detail_questions_tab_l'"
        [currentStepValid]="form.controls.detailQuestions.status === 'VALID'"
        (next)="sideSheetFormComponent.nextTab()"
      >
        <rs-web-ticket-detail-questions
          [formArray]="detailQuestionsFormArray"
          [questions]="detailQuestionsResponse.detailRootQuestion.questions"
          [ticketType]="type"
          class="primary-text"
        ></rs-web-ticket-detail-questions>
      </ng-template>
    }
    @if (showSuccessStep()) {
      <ng-template
        rsWebSideSheetContent
        [customDoneButtonText]="'back_to_overview_l'"
        [label]="'ticket_summary.overview_l'"
        (done)="dismiss()"
      >
        <rs-web-success-screen>
          <h2 class="title">{{ 'ticket_creation.success.title_l' | translate }}</h2>

          <p class="primary-text">{{ 'ticket_creation.success.text_1_l' | translate }}</p>
          <p class="primary-text">{{ 'ticket_creation.success.text_2_l' | translate }}</p>
          <p class="primary-text">{{ 'ticket_creation.success.text_3_l' | translate }}</p>
          <p class="primary-text">{{ 'ticket_creation.success.text_metadata_l' | translate }}</p>
        </rs-web-success-screen>
      </ng-template>
    } @else if (showErrorStep()) {
      <ng-template
        rsWebSideSheetContent
        [customDoneButtonText]="'back_to_overview_l'"
        [label]="'ticket_summary.overview_l'"
        (done)="dismiss()"
      >
        <rs-web-error-screen>
          <h2 class="error-title">{{ 'user_edit_error_title' | translate }}</h2>
          <p>{{ 'ticket_creation.error_screen_message_l' | translate }}</p>

          <button
            im-button
            class="primary"
            (click)="createTicket()"
            [disabled]="saveTicketActionState()?.pending || detailQuestionsActionState()?.pending"
          >
            {{ 'ticket_creation.try_again_a' | translate }}
          </button>
        </rs-web-error-screen>
      </ng-template>
    } @else if (showSummaryStep()) {
      <ng-template
        rsWebSideSheetContent
        [label]="'ticket_summary.overview_l'"
        (done)="createTicket()"
      >
        <rs-web-ticket-summary></rs-web-ticket-summary>
      </ng-template>
    }
  </rs-web-side-sheet-form>
} @else {
  <rs-web-ticket-direct-assignment
    [title]="
      type === TicketIssueType.PROPERTY_DAMAGE
        ? 'ticket_damage.create_new_b'
        : 'ticket_request.create_new_b'
    "
    [contacts]="contacts()"
  ></rs-web-ticket-direct-assignment>
}
